import React, { useRef } from 'react';
import { formatToDisplayDate, parseDisplayDate, isISOFormat } from '../services/dateFormatter';

export default function DateInput({ value, onChange, placeholder = 'DD/MM/YYYY', title, disabled, className, style }) {
  const hiddenRef = useRef(null);

  const displayValue = value ? (isISOFormat(value) ? formatToDisplayDate(value) : value) : '';
  const isoValue = parseDisplayDate(displayValue);

  const openPicker = () => {
    if (!hiddenRef.current) return;
    // modern browsers support showPicker(); otherwise focus+click
    try {
      if (typeof hiddenRef.current.showPicker === 'function') hiddenRef.current.showPicker();
      else hiddenRef.current.click();
    } catch (e) {
      hiddenRef.current.click();
    }
  };

  const onDateChange = e => {
    const iso = e.target.value; // YYYY-MM-DD
    const disp = iso ? formatToDisplayDate(iso) : '';
    onChange && onChange(disp);
  };

  const onTextChange = e => onChange && onChange(e.target.value);

  return (
    <div className={"date-input"} style={{ position: 'relative', display: 'flex', alignItems: 'center', width: '100%', minWidth: 0 }}>
      <input
        type="text"
        value={displayValue || ''}
        onChange={onTextChange}
        placeholder={placeholder}
        title={title}
        disabled={disabled}
        className={className}
        style={{ paddingRight: '2rem', boxSizing: 'border-box', width: '100%', minWidth: 0, ...style }}
      />

      <input
        ref={hiddenRef}
        type="date"
        value={isoValue || ''}
        onChange={onDateChange}
        aria-hidden="true"
        style={{ position: 'absolute', right: 0, top: 0, width: '36px', height: '100%', opacity: 0, border: 'none', background: 'transparent', padding: 0, margin: 0, cursor: 'pointer' }}
      />

      <button type="button" onClick={openPicker} aria-label="Open date picker" style={{ position: 'absolute', right: '.5rem', top: '50%', transform: 'translateY(-50%)', border: 'none', background: 'transparent', padding: 0, margin: 0, cursor: 'pointer' }}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
          <rect x="3" y="4" width="18" height="18" rx="2" stroke="#94a3b8" strokeWidth="1.5" fill="none" />
          <path d="M16 2V6M8 2V6M3 10H21" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>
    </div>
  );
}
